export default __webpack_public_path__ + "static/benedek_bw-610366ceef1524ad700487508015734c.jpg";